import React from 'react';
import StepElement from '@components/organisms/MultiStepForm/Steps/StepElement/StepElement';
import {IntroPageWrapper, IntroPageContainer} from './IntroPage.styled';

const IntroPage = ({
  currentStep,
  maxStep,
  formDataContext,
  trainingId,
  phrases,
  handleNextStep,
  handleFormData,
  isSubmitting,
  visibleSteps,
  config,
}) => {
  return (
    <IntroPageWrapper>
      <IntroPageContainer>
        {config
          .filter((step) => step.index === visibleSteps[0]?.index)
          .map((filteredStep) => (
            <React.Fragment key={filteredStep.index}>
              <StepElement
                stepData={filteredStep}
                formDataContext={formDataContext}
                trainingId={trainingId}
                phrases={phrases}
                handleNextStep={() => {
                  handleNextStep(visibleSteps[0]?.index);
                }}
                handleFormData={handleFormData}
                isSubmitting={isSubmitting}
                currentStep={currentStep}
                maxStep={maxStep}
                introPage={true}
              />
            </React.Fragment>
          ))}
      </IntroPageContainer>
    </IntroPageWrapper>
  );
};

export default IntroPage;
